const BootBox = (($) => {

    const NAME = 'bootbox';
    const DATA_KEY = `bs.${NAME}`;
    const EVENT_KEY = `.${DATA_KEY}`;
    const DATA_API_KEY = '.data-api';
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {
        callback: null,
        className: null,
        close: true,
        esc: true,
        inputType: 'text',
        inputValue: null,
        inputOptions: null,
        message: '',
        size: null,
        title: '',
        cancelText: 'Cancel',
        cancelClassName: 'btn-default',
        confirmText: 'Confirm',
        confirmClassName: 'btn-primary'
    };
    const Event = {
        CLICK_DATA_API: `click${EVENT_KEY}${DATA_API_KEY}`
    };
    const Selector = {
        ALERT: `.js-${NAME}-alert`,
        CONFIRM: `.js-${NAME}-confirm`,
        PROMPT: `.js-${NAME}-prompt`,
        CUSTOM: `.js-${NAME}-custom`
    };

    class BootBox {
        constructor(element, config) {
            this._config = config;
            this._element = element;
            this._tagName = element.tagName.toLowerCase();

            $(this._element).closest('.dropdown.open').removeClass('open');
        }

        alert() {
            bootbox.alert({
                buttons: {
                    ok: {
                        label: this._config.confirmText,
                        className: this._config.confirmClassName
                    }
                },
                // TODO: does alert really need a callback?
                callback: (...args) => {
                    if (this._config.callback) {
                        this._callback(args);
                    } else {
                        if (this._tagName === 'a') {
                            this._anchorClick();
                        } else {
                            this._formSubmit();
                        }
                    }
                },
                className: this._config.className,
                closeButton: this._config.close,
                onEscape: this._config.esc,
                message: this._config.message,
                size: this._config.size,
                title: this._config.title
            });
        }
        confirm() {
            bootbox.confirm({
                buttons: {
                    cancel: {
                        label: this._config.cancelText,
                        className: this._config.cancelClassName
                    },
                    confirm: {
                        label: this._config.confirmText,
                        className: this._config.confirmClassName
                    }
                },
                callback: (...args) => {
                    if (this._config.callback) {
                        this._callback(args);
                    } else if (args[0]) {
                        if (this._element.tagName === 'A') {
                            this._anchorClick();
                        } else {
                            this._formSubmit();
                        }
                    }
                },
                className: this._config.className,
                closeButton: this._config.close,
                onEscape: this._config.esc,
                message: this._config.message,
                size: this._config.size,
                title: this._config.title
            });
        }
        prompt() {
            bootbox.prompt({
                buttons: {
                    cancel: {
                        label: this._config.cancelText,
                        className: this._config.cancelClassName
                    },
                    confirm: {
                        label: this._config.confirmText,
                        className: this._config.confirmClassName
                    }
                },
                callback: (...args) => {
                    if (this._config.callback) {
                        this._callback(args);
                    } else if (args[0]) {
                        if (this._element.tagName === 'A') {
                            this._anchorClick();
                        } else {
                            this._formSubmit();
                        }
                    }
                },
                className: this._config.className,
                closeButton: this._config.close,
                value: this._config.inputValue,
                inputType: this._config.inputType,
                inputOptions: this._config.inputOptions,
                onEscape: this._config.esc,
                //message: this._config.message, this is not supported
                size: this._config.size,
                title: this._config.title
            });

            if (this._config.inputType === 'checkbox' || this._config.inputType === 'select') {
                $(`.bootbox-input-${this._config.inputType}`)[this._config.inputType]();
            }
        }
        custom() {
            bootbox.dialog({
                buttons: {
                    cancel: {
                        label: this._config.cancelText,
                        className: this._config.cancelClassName
                    },
                    confirm: {
                        label: this._config.cofirmText,
                        className: this._config.confirmClassName
                    }
                },
                callback: (...args) => {
                    if (this._config.callback) {
                        this._callback(args);
                    } else if (args[0]) {
                        if (this._element.tagName === 'A') {
                            this._anchorClick();
                        } else {
                            this._formSubmit();
                        }
                    }
                },
                className: this._config.className,
                closeButton: this._config.close,
                onEscape: this._config.esc,
                message: this._config.message,
                size: this._config.size,
                title: this._config.title
            });
        }

        _callback(args) {
            if (typeof this._config.callback === 'function') {
                this._config.callback.apply(this._element, args);
            } else {
                $.getFunction(this._config.callback, ["value"]).apply(this._element, args);
            }
        }
        _anchorClick() {
            // if anchor, we will try and redirect or initiate ajax
            const url = $(this._element).attr('href');
            if (this._config.ajax) {
                console.error('ajax is not supported .. please provide callback');
            } else if (url !== '#') {
                location.href = url;
            }
        }
        _formSubmit() {
            const $button = $(this._element),
                type = $button.prop('type').toLowerCase();
            if (this._tagName === 'button' || this._tagName === 'input') {
                let $form;
                if (this._tagName === 'button') {
                    $form = $($button.prop('form'));
                    if (!$form.length) {
                        $form = $button.closest('form');
                    }
                } else {
                    $form = $button.closest('form');
                }

                if (type === 'submit') {
                    $form.submit();
                } else if (type === 'reset') {
                    $form[0].reset();
                }
            }
        }

        dispose() {
            $.removeData(this._element, DATA_KEY);
            this._config = null;
            this._element = null;
        }


        static _jQueryInterface(type) {
            return this.each(function () {
                const $this = $(this);
                let data = $this.data(DATA_KEY);
                const config = $.extend({}, Default, $this.data());
                if (!data) {
                    data = new BootBox(this, config);
                    $(this).data(DATA_KEY, data);
                }

                data[type]();
            });
        }
    }

    $(document)
        .on(Event.CLICK_DATA_API, Selector.ALERT, function (event) {
            event.preventDefault();
            BootBox._jQueryInterface.call($(this), 'alert');
        }).on(Event.CLICK_DATA_API, Selector.CONFIRM, function (event) {
            event.preventDefault();
            BootBox._jQueryInterface.call($(this), 'confirm');
        }).on(Event.CLICK_DATA_API, Selector.PROMPT, function (event) {
            event.preventDefault();
            BootBox._jQueryInterface.call($(this), 'prompt');
        }).on(Event.CLICK_DATA_API, Selector.CUSTOM, function (event) {
            event.preventDefault();
            BootBox._jQueryInterface.call($(this), 'custom');
        });

    $.fn[NAME] = BootBox._jQueryInterface;
    $.fn[NAME].Constructor = BootBox;
    $.fn[NAME].noConflict = function() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return BootBox._jQueryInterface;
    };

    return BootBox;
})(jQuery);